export const WIZARD_DATA_INITIALIZED = "MainWizardScreen/ORDER_CONSTANTS_FETCHED";
export const SCREEN_CHANGED = "MainWizardScreen/SCREEN_CHANGED";
export const ORDER_FETCHED_AND_STEP_FORWARD = "MainWizardScreen/ORDER_FETCHED_AND_STEP_FORWARD"
export const PRODUCT_SELECTED = "MainWizardScreen/PRODUCT_SELECTED"
export const NAVIGATE_WIZARD_STEP = "MainWizardScreen/NAVIGATE_WIZARD_STEP"
export const SET_PRODUCT_CATEGORY_STATE = "MainWizardScreen/SET_PRODUCT_CATEGORY_STATE"
export const BACK_TO_PRODUCTS_SCREEN = "MainWizardScreen/BACK_TO_PRODUCTS_SCREEN"
export const DROP_DOWN_VALUES_SET = "MainWizardScreen/DROP_DOWN_VALUES_SET"
